<template>
  <HighFrequencyGameOptionCard
    body-class="pt-300"
    class="high-frequency-game-quantity-selector"
    :headline="$t('highfrequencygame.quantityselector.headline')"
    :subtitle="$t('highfrequencygame.quantityselector.subtitle')"
  >
    <LcRadioGroup v-model:value="model" class="wrap" no-feedback>
      <LcCard
        v-for="{ discount, values } in numberColumns"
        :key="discount"
        body-class="flex flex-col p-100 pt-200 gap-100"
        :class="[
          'quantities',
          discount > 0 ? 'bg-accent-win-win' : 'bg-secondary-secondary-disabled',
        ]"
        shadow="none"
      >
        <HighFrequencyGameDiscountBadge v-if="discount > 0" v-bind="{ discount }" />

        <LcRadioCard
          v-for="{ value } in values"
          :key="value"
          v-bind="{ value }"
          body-class="quantity px-100 pr-300 paragraph-regular"
          :label="String(value)"
        />
      </LcCard>
    </LcRadioGroup>
  </HighFrequencyGameOptionCard>
</template>

<script lang="ts" setup>
import type { HighFrequency_AllowedNumberOfDrawsGroup } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Props = {
  numbers?: HighFrequency_AllowedNumberOfDrawsGroup[]
}

const { numbers = [] } = defineProps<Props>()

const model = defineModel({ default: 1, type: Number })

const numberColumns = computed(() => {
  if (numbers.length !== 1) return numbers

  const { discount, values } = numbers[0]
  const half = Math.ceil(values.length / 2)

  return [
    { discount, values: values.slice(0, half) },
    { discount, values: values.slice(half) },
  ]
})
</script>

<style lang="scss" scoped>
.high-frequency-game-quantity-selector {
  .quantities {
    position: relative;

    .discount {
      position: absolute;
      top: -0.9375rem;
      right: token('size/space/gap/100');
    }

    :deep(.quantity) {
      padding-block: 0.375rem;
    }
  }

  .wrap {
    /* stylelint-disable-next-line selector-class-pattern */
    :deep(.lc-radio-group__wrap) {
      grid-template-columns: repeat(2, 1fr);
      gap: token('size/space/gap/200') token('size/space/gap/100');

      &:has(> :only-child) {
        grid-template-columns: 1fr;
      }

      > * {
        align-self: flex-start;
      }
    }
  }
}
</style>
